import styled from 'styled-components'

export const BlogCollectionRowContainer = styled.div`
  ${({ theme }) => {
    return `
      .BlogCollectionRow__Container {
        padding: 48px 0px;

        ${theme.breakpoints.down('sm')} {
          align-items: center;
        }

        ${theme.breakpoints.down('xs')} {
          padding: 48px 26px;
        }

        .BlogCollectionRow__Headline-Container {
          position: relative;
          padding: 48px 48px 48px 8px;
          overflow-wrap: anywhere;
          hyphens: auto;

          ${theme.breakpoints.down('sm')} {
            padding: 48px 94px 48px 94px;
          }

          ${theme.breakpoints.down('xs')} {
            display: flex;
            padding: 24px 0px;
            align-items: center;
          }
  
          img {
            margin-bottom: 16px;

            ${theme.breakpoints.down('xs')} {
              width: 68px;
              height: 60px;
              margin-bottom: 0px;
              margin-right: 16px;
            }
          }
  
          &:before {
            content: '';
            position: absolute;
            z-index: -1;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-image: radial-gradient(#cccccc 1px, transparent 0);
            background-repeat: repeat;
            background-size: 24px 24px;
            background-position: left top;
            margin-right: 8px;
          }
        }
  
        .BlogCollectionRow__Category-Container {
          padding: 64px 16px 16px 16px;

          ${theme.breakpoints.down('sm')} {
            padding: 16px 8px;
          }
          
          ${theme.breakpoints.down('xs')} {
            padding: 16px 0px;
          }
        }
  
        .BlogCollectionRow__Header {
          margin-bottom: 16px;
        }
  
        .BlogCollectionRow__Description {
          margin-bottom: 16px;
        }
      }
    `
  }}
`
